<div *ngIf="isLoading" class="overlay">
  <div class="transparentCover"></div>
  <div class="loading"></div>
</div>
